// extracted by mini-css-extract-plugin
export default {"heading":"TransactionsTable_heading__d6OTW","table":"TransactionsTable_table__xu6ZB","red":"TransactionsTable_red__L6fqd","green":"TransactionsTable_green__HUu9z"};